import useFetch from './use-fetch';
import { UseFetch } from './interfaces';

const useNonInitialFetch: UseFetch.Fetch = (url, options) => useFetch(url, { ...options, initialMount: false });

export default useNonInitialFetch;